import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadLaboratories: ILaboratoriesLoadActionCreator = () => {
        return {
            type: ACTION_LABORATORIES_LOAD
        }
    },
    LoadLaboratoryById: ILaboratoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_LABORATORIES_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ILaboratoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORIES_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ILaboratoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORIES_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveLaboratory: ILaboratorySaveActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORIES_SAVE,
            formData
        }
    },
    SaveSuccess: ILaboratorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORIES_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ILaboratorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORIES_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateLaboratory: ILaboratoryCreateActionCreator = () => {

        return {
            type: ACTION_LABORATORIES_CREATE
        }
    },
    CreateSuccess: ILaboratoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_LABORATORIES_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ILaboratoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORIES_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateLaboratory: ILaboratoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORIES_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ILaboratoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORIES_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ILaboratoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORIES_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ILaboratoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_LABORATORIES_CLEAR,
            propertiesToClear
        }
    },

    Filter: ILaboratoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_LABORATORIES_FILTER,
            formFilter
        }
    };



export const
    ACTION_LABORATORIES_LOAD = "ACTION_LABORATORIES_LOAD",
    ACTION_LABORATORIES_LOAD_BY_ID = "ACTION_LABORATORIES_LOAD_BY_ID",
    ACTION_LABORATORIES_LOAD_SUCCESS = "ACTION_LABORATORIES_LOAD_SUCCESS",
    ACTION_LABORATORIES_LOAD_FAILURE = "ACTION_LABORATORIES_LOAD_FAILURE",

    ACTION_LABORATORIES_SAVE = "ACTION_LABORATORIES_SAVE",
    ACTION_LABORATORIES_SAVE_SUCCESS = "ACTION_LABORATORIES_SAVE_SUCCESS",
    ACTION_LABORATORIES_SAVE_FAILURE = "ACTION_LABORATORIES_SAVE_FAILURE",

    ACTION_LABORATORIES_CREATE = "ACTION_LABORATORIES_CREATE",
    ACTION_LABORATORIES_CREATE_SUCCESS = "ACTION_LABORATORIES_CREATE_SUCCESS",
    ACTION_LABORATORIES_CREATE_FAILURE = "ACTION_LABORATORIES_CREATE_FAILURE",

    ACTION_LABORATORIES_VALIDATE = "ACTION_LABORATORIES_VALIDATE",
    ACTION_LABORATORIES_VALIDATE_SUCCESS = "ACTION_LABORATORIES_VALIDATE_SUCCESS",
    ACTION_LABORATORIES_VALIDATE_FAILURE = "ACTION_LABORATORIES_VALIDATE_FAILURE",

    ACTION_LABORATORIES_CLEAR = "ACTION_LABORATORIES_CLEAR",

    ACTION_LABORATORIES_FILTER = "ACTION_LABORATORIES_FILTER";

export interface ILaboratoriesLoadAction {
    type: "ACTION_LABORATORIES_LOAD";
}

export interface ILaboratoriesLoadActionCreator {
    (): ILaboratoriesLoadAction;
}

export interface ILaboratoryLoadSuccessAction {
    type: "ACTION_LABORATORIES_LOAD_SUCCESS";
    formData: Dtos.Laboratory | Dtos.Laboratory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryLoadSuccessActionCreator {
    (
        formData: Dtos.Laboratory | Dtos.Laboratory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryLoadSuccessAction;
}

export interface ILaboratoryLoadFailureAction {
    type: "ACTION_LABORATORIES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryLoadFailureAction;
}

export interface ILaboratoryLoadByIdAction {
    type: "ACTION_LABORATORIES_LOAD_BY_ID";
    id: number;
}

export interface ILaboratoryLoadByIdActionCreator {
    (id: number): ILaboratoryLoadByIdAction;
}


export interface ILaboratorySaveAction {
    type: "ACTION_LABORATORIES_SAVE";
    formData: Dtos.Laboratory;

}

export interface ILaboratorySaveActionCreator {
    (
        formData: Dtos.Laboratory
    ): ILaboratorySaveAction;
}

export interface ILaboratorySaveSuccessAction {
    type: "ACTION_LABORATORIES_SAVE_SUCCESS";
    formData: Dtos.Laboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratorySaveSuccessActionCreator {
    (
        formData: Dtos.Laboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratorySaveSuccessAction;
}

export interface ILaboratorySaveFailureAction {
    type: "ACTION_LABORATORIES_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratorySaveFailureAction;
}

export interface ILaboratoryCreateAction {
    type: "ACTION_LABORATORIES_CREATE"
}

export interface ILaboratoryCreateActionCreator {
    (): ILaboratoryCreateAction
}

export interface ILaboratoryCreateSuccessAction {
    type: "ACTION_LABORATORIES_CREATE_SUCCESS";
    formData: Dtos.Laboratory;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ILaboratoryCreateSuccessActionCreator {
    (
        formData: Dtos.Laboratory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ILaboratoryCreateSuccessAction;
}

export interface ILaboratoryCreateFailureAction {
    type: "ACTION_LABORATORIES_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryCreateFailureAction;
}

export interface ILaboratoryValidateAction {
    type: "ACTION_LABORATORIES_VALIDATE";
    formData: Dtos.Laboratory;

}

export interface ILaboratoryValidateActionCreator {
    (
        formData: Dtos.Laboratory
    ): ILaboratoryValidateAction;
}

export interface ILaboratoryValidateSuccessAction {
    type: "ACTION_LABORATORIES_VALIDATE_SUCCESS";
    formData: Dtos.Laboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryValidateSuccessActionCreator {
    (
        formData: Dtos.Laboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryValidateSuccessAction;
}

export interface ILaboratoryValidateFailureAction {
    type: "ACTION_LABORATORIES_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryValidateFailureAction;
}

export interface ILaboratoryClearAction {
    type: "ACTION_LABORATORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface ILaboratoryClearActionCreator {
    (propertiesToClear?: string[]): ILaboratoryClearAction;
}

export interface ILaboratoryFilterActionCreator {
    (formFilter: IFormFilter): ILaboratoryFilterAction;
}

export interface ILaboratoryFilterAction {
    type: "ACTION_LABORATORIES_FILTER";
    formFilter: IFormFilter;
}

export type LaboratoryAction =
    ILaboratoriesLoadAction |
    ILaboratoryLoadByIdAction |
    ILaboratoryLoadFailureAction |
    ILaboratoryLoadSuccessAction |
    ILaboratorySaveAction |
    ILaboratorySaveSuccessAction |
    ILaboratorySaveFailureAction |
    ILaboratoryCreateAction |
    ILaboratoryCreateSuccessAction |
    ILaboratoryCreateFailureAction |
    ILaboratoryValidateAction |
    ILaboratoryValidateSuccessAction |
    ILaboratoryValidateFailureAction |
    ILaboratoryClearAction |
    ILaboratoryFilterAction;
